

function prevTabFunc() {
  var currTab = document.querySelectorAll(".annuities-types__table-mobile-nav ul .active")[0];
  var prevTab = currTab.previousElementSibling;

  if (prevTab) {
    currTab.classList.remove("active");
    prevTab.classList.add("active");

    var actives = document.querySelectorAll(".annuities-types__table-mobile .active");
    actives.forEach(el => {
      var next = el.previousElementSibling;
      next.classList.add("active");
      el.classList.remove("active");
  	});
  }
}

function nextTabFunc() {
  var currTab = document.querySelectorAll(".annuities-types__table-mobile-nav ul .active")[0];
  var nextTab = currTab.nextElementSibling;

  if (nextTab) {
    currTab.classList.remove("active");
    nextTab.classList.add("active");

    var actives = document.querySelectorAll(".annuities-types__table-mobile .active");
    actives.forEach(el => {
      var next = el.nextElementSibling;
      next.classList.add("active");
      el.classList.remove("active");
  	});
  }
}

export default function annuitiesTable() {

  var prevTab = document.querySelectorAll('.annuities-types__table-mobile-nav .tab-nav.prev');
  prevTab.forEach(el => {
		el.addEventListener('click', prevTabFunc);
	});

  var nextTab = document.querySelectorAll('.annuities-types__table-mobile-nav .tab-nav.next');
  nextTab.forEach(el => {
		el.addEventListener('click', nextTabFunc);
	});


}
